import { applyMiddleware } from "redux";

import { autoRehydrate } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import bagMiddleware from "./middleware/bag";
import thunk from "redux-thunk";
import * as api from "../../api";

export default () =>
  composeWithDevTools(
    applyMiddleware(
      thunk.withExtraArgument({
        api,
        get identity() {
          return window.__sdk.identity;
        }
      }),
      bagMiddleware
    ),
    autoRehydrate()
  );



// WEBPACK FOOTER //
// ./template/state/enhancers.js